// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"83b8b154","455":"a445887d","977":"bb5c8f66"}[chunkId] + ".chunk.js";
};